import axios from '../utils/axios';

const SurveyService = {
    getSurveys:        (p={})  => axios.get('survey', {params:p}),
    getPublicSurveys:  ()      => axios.get('survey/my'),
    getSurveyDetail:   (id)    => axios.get(`survey/${id}`),
    saveSurvey:        (data)  => axios.post('survey/save', data),
    publishSurvey:     (id)    => axios.post(`survey/${id}/publish`),
    closeSurvey:       (id)    => axios.post(`survey/${id}/close`),
    deleteSurvey:      (id)    => axios.post(`survey/${id}/delete`),
    saveQuestions:     (id, d) => axios.post(`survey/${id}/questions`, d),
    saveResponse:      (id, d) => axios.post(`survey/${id}/respond`, d),
    getAnalytics:      (id)    => axios.get(`survey/${id}/analytics`),
    getResponses:      (id)    => axios.get(`survey/${id}/responses`),
    assignCollectors:          (id, d)  => axios.post(`survey/${id}/collectors`, d),
    generatePublicLink:        (id)     => axios.post(`survey/${id}/public-link`),
    revokePublicLink:          (id)     => axios.post(`survey/${id}/revoke-link`),
    getProgrammeCollectors:    (pid)    => axios.get(`survey/programme/${pid}/collectors`),
    assignProgrammeCollectors: (pid, d) => axios.post(`survey/programme/${pid}/collectors`, d),
    getProgress:               (id)     => axios.get(`survey/${id}/progress`),
    exportResponses:           (id)     => axios.get(`survey/${id}/export`, {responseType:'blob'}),
    getCollectors:             (id)     => axios.get(`survey/${id}/collectors`),
    inviteCollector:           (id, d)  => axios.post(`survey/${id}/collectors/invite`, d),
    removeCollector:           (cid)    => axios.post(`survey/0/collectors/${cid}`),
    updateCollector:           (cid, d) => axios.post(`survey/0/collectors/update/${cid}`, d),
    getCollaborators:          (id)     => axios.get(`survey/${id}/collaborators`),
    inviteCollaborator:        (id, d)  => axios.post(`survey/${id}/collaborators/invite`, d),
    updateCollaboratorRole:    (cid, d) => axios.post(`survey/collaborators/${cid}/role`, d),
    removeCollaborator:        (cid)    => axios.post(`survey/collaborators/${cid}/remove`),
    validateInviteToken:       (token)  => axios.get('survey/validate-invite', { params: { token } }),
    exportXLSForm:             (id)     => axios.get(`survey/${id}/xlsform`),

// ==================== Survey promotion / template library ====================
submitForReview:   (id)          => axios.post(`survey/${id}/submit-for-review`),
getPendingReview:  ()            => axios.get('survey/pending-review'),
approvePromotion:  (id)          => axios.post(`survey/${id}/approve-promotion`),
rejectPromotion:   (id, notes)   => axios.post(`survey/${id}/reject-promotion`, { notes }),
getTemplateLibrary:()            => axios.get('survey/templates'),
cloneTemplate:     (id)          => axios.post(`survey/${id}/clone-template`),

// ==================== Section-scoped collectors ====================
markSubmitted:     (id, facility_id) => axios.post(`survey/${id}/mark-submitted`, { facility_id }),
getSectionProgress:(id, facility_id) => axios.get(`survey/${id}/section-progress`, { params: { facility_id } }),
};
export default SurveyService;
